/**
 * @desc 查询入库计划单信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.inPlanFacadeImpl.getInPlanMaster.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inPlan/getInPlanMaster`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
